<div class="h-screen bg-white grid place-items-center text-lg tk-bg-gray-1">
  {{'logout.message' | translate}}
</div>

